import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { I18NService } from '@ebw-monorepo/i18n-translate';
import { LoginService } from '@ebw-monorepo/login';
import { CONFIG_SERVICE_ADAPTER, IConfigService, MapService, MapTableComponent } from '@ebw-monorepo/map';
import { EbwModalService } from '@ebw-monorepo/modal';
import { SplitViewService } from '@ebw-monorepo/utils';
import { SplitViewConf } from 'libs/ng-components/utils/src/lib/models/split-view-conf';
import { MapBrowserEvent } from 'ol';
import { transform } from 'ol/proj';
import { Subscription } from 'rxjs';
import { IHttpMapGet } from '../../../interfaces/httpReq.interface';
import { MapRequestService } from '../../../services/map-request.service';
import { MapTableService } from './../../../services/map-table.service';
import { API_URLS, ApiUrlService } from '../../../../../../utils/src/lib/services/api-url.service';

@Component({
  selector: 'ebw-monorepo-valve',
  templateUrl: './valve.component.html',
  styleUrls: ['./valve.component.scss']
})
export class ValveComponent implements OnInit, OnDestroy {
  /** Il pannello tiene il click sulla mappa ("strong") per tutta la sua vita; la route è protetta da un guard (map-routing.module) */
  static readonly CLICK_OWNER_ID = 'valve';

  mapClickSub: Subscription;
  private _clickOwned = false;
  private _contextId = 'valve_table';

  constructor(
    private ebwModalSrv: EbwModalService,
    private i18nSrv: I18NService,
    private httpSrv: MapRequestService,
    private mapSrv: MapService,
    private mapTableSrv: MapTableService,
    private _splitViewService: SplitViewService,
    private _apiUrlService: ApiUrlService,
    @Inject(CONFIG_SERVICE_ADAPTER) private _configService: IConfigService
  ) {}

  ngOnInit(): void {
    // il guard ha già verificato che il click sia disponibile: l'acquisizione va fatta prima del flag
    this._clickOwned = this.mapSrv.acquireMapClick({ id: ValveComponent.CLICK_OWNER_ID, level: 'strong' });
    if (!this._clickOwned) {
      return;
    }
    this.mapSrv.customMapClickEnable$.next(true);

    this.mapClickSub = this.mapSrv.mapClicked$.subscribe((event) => {
      this.clickHandler(event);
    });
  }

  getUrnFromCoordinates(lat: number, long: number) {
    const point = transform([long, lat], MapService.EPSG_3857_KEY, MapService.EPSG_4326_KEY);

    const valveConfig = this._configService.getConfigGlobale().api.details.valveSearch;

    const url =
      this._apiUrlService.createUrl(API_URLS.MAP.CORE.CHECK_GRANT) +
      `?request_type=select&filter=PNI&hit_radius=${valveConfig.hit_radius}&objects=${valveConfig.objects}`;
    let req: IHttpMapGet = {
      url: url + '&lat=' + point[1] + '&lng=' + point[0],
      user_id: sessionStorage.getItem(LoginService.USER_ID_KEY)
    };

    this.httpSrv.getMapRequest(req).subscribe({
      next: (resp: any) => {
        if (resp && resp.result) {
          let features = resp.result.features.filter(
            (el) => el.id.includes('wa_pipe') || el.id.includes('wa_pod_link')
          );
          if (features.length > 0) {
            this.getValves(features[0].id);
          } else {
            this.ebwModalSrv.openErrorModal({
              title: this.i18nSrv.getInstantValue('common.error'),
              content: this.i18nSrv.getInstantValue('map.sidebar.valve.elment_not_allowed')
            });
          }
        } else {
          this.ebwModalSrv.openErrorModal({
            title: this.i18nSrv.getInstantValue('common.error'),
            content: this.i18nSrv.getInstantValue('common.data_retrieving_error')
          });
        }
      },
      error: (error) => {
        this.ebwModalSrv.openErrorModal({
          title: this.i18nSrv.getInstantValue('common.error'),
          content: this.i18nSrv.getInstantValue('common.data_retrieving_error')
        });
      }
    });
  }

  getValves(urn: string) {
    let config = {
      id: null,
      url: this._apiUrlService.createUrl(API_URLS.MAP.WATER.VALVE_SEACH) + '?urn=' + urn + '&type=primary',
      token: sessionStorage.getItem(LoginService.AUTH_TOKEN_KEY),
      title: 'map.sidebar.valve.my_valve',
      pagination: false,
      showLevels: true,
      marker: 'tag'
    };

    const splitViewConf: SplitViewConf = {
      title: config.title,
      icon: 'table_view'
    };

    this._splitViewService.show(MapTableComponent, this._contextId, null, splitViewConf);
    this.mapTableSrv.setMapTableConfig(config);
  }

  clickHandler(event: MapBrowserEvent<any>) {
    if (event.coordinate.length > 0) {
      let coords = event.coordinate;
      this.getUrnFromCoordinates(coords[1], coords[0]);
    }
  }

  ngOnDestroy() {
    if (this.mapClickSub) {
      this.mapClickSub.unsubscribe();
    }
    // se il click non è stato acquisito il flag appartiene ad altri
    if (this._clickOwned) {
      this.mapSrv.customMapClickEnable$.next(false);
      // il flag va spento prima di rilasciare il registro (un passive in attesa lo riaccende)
      this.mapSrv.releaseMapClick(ValveComponent.CLICK_OWNER_ID);
    }
  }
}
